module.exports = __webpack_public_path__ + "static/media/ra.a9e85a27.png";